export default {
  getPersonalLeaveEntitlementForm: (state) => state.form,
  getPersonalLeaveEntitlementFormBusy: (state) => state.isBusy,
};
